import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "./Featured.css";
import { useContext } from "react";
import { ThemeContext } from "../../Contexts/ThemeContext";
import { Link } from "react-router-dom";
import banner1 from "../../Images/face.webp";
import banner2 from "../../Images/eyes.webp";
import banner3 from "../../Images/lip.jpg";
import banner4 from "../../Images/nails.webp";
import banner5 from "../../Images/website-category-banner-accessories.webp";

const Featured = () => {
  return (
    <div className=" 2xl:w-[80%] lg:w-[85%] mx-auto featured ">
      <div className="flex flex-col items-center w-[100%]">
        <Link to="/search/flormar">
          <img className="rounded-2xl h-[200px]" src="https://media-cldnry.s-nbcnews.com/image/upload/t_fit-1500w,f_auto,q_auto:best/rockcms/2024-06/240610-beauty-awards-2024-face-makeup-winners-vl-social-74fb90.jpg" alt="face products" />
        </Link>
        <Link to="/search/flormar" className="text-center">
          <p className="text-secondary mt-6 font-bold mb-10 sm:mb-0">MAKEUP</p>
        </Link>
      </div>

      <div className="flex flex-col items-center w-[100%]">
        <Link to="/product-category/skin care">
          <img className="rounded-2xl h-[200px]" src="https://www.skincenterofsouthmiami.com/wp-content/uploads/2018/06/Skin-Center-of-South-Miami-Facials-and-Skin-Care.jpg" alt="best eye makeup products" />
        </Link>
        <Link to="/product-category/skin care" className="text-center">
          <p className="text-secondary mt-6 font-bold mb-10 sm:mb-0">SKINCARE</p>
        </Link>
      </div>

      <div className="flex flex-col items-center w-[100%]">
        <Link to={`/product-category/hair care`}>
          <img className="rounded-2xl h-[200px] w-[274px] h-[180px]" src="https://www.vcareproducts.com/storage/app/public/files/133/Banner/main%20category/Hair.webp" alt="lipstick" />
        </Link>
        <Link to={`/product-category/hair care`} className="text-center">
          <p className="text-secondary mt-6 font-bold mb-10 sm:mb-0">HAIRCARE</p>
        </Link>
      </div>

      <div className="flex flex-col items-center w-[100%]">
        <Link to={`/product-category/personal care`}>
          <img className="rounded-2xl h-[200px]" src="https://luvit.com.bd/wp-content/uploads/2025/10/maxresdefault.jpg" alt="nail makeup products" />
        </Link>
        <Link to={`/product-category/personal care`} className="text-center">
          <p className="text-secondary mt-6 font-bold mb-10 sm:mb-0">PERSONAL CARE</p>
        </Link>{" "}
      </div>

      <div className="flex flex-col items-center w-[100%]">
        <Link to="/product-category/fragrances">
          <img className="rounded-2xl h-[200px]" src="https://luvit.com.bd/wp-content/uploads/2025/10/Buy_Armaf_Club_De_Nuit_Intense_Online_1920x_crop_center-1300x650.webp" alt="makeup accessories" />
        </Link>
        <Link to="/product-category/fragrances" className="text-center">
          <p className="text-secondary mt-6 font-bold">FRAGRANCES</p>
        </Link>
      </div>
    </div>
  );
};

export default Featured;
